// extracted by mini-css-extract-plugin
module.exports = {"dropdownTitle":"_3RC0w","expanded":"_1n_YU","arrow":"_309IU","text":"_2IJlD"};